export default __webpack_public_path__ + "static/media/47.a5e36de8.png";